export const blogs = {
  blogsFeedCreateInputPlaceholder: 'Schreibe einen Beitrag...',
  blogsFeedSearchInputPlaceholder: 'Suchen',
  blogsFeedPostOwnerCurtainEditTitle: 'Beitrag bearbeiten',
  blogsFeedPostOwnerCurtainDeleteTitle: 'Beitrag löschen',
  blogsFeedEditedPostSavedAlertText: 'Beitrag gespeichert!',
  blogsFeedEditedPostDeletedAlertText: 'Beitrag gelöscht!',
  blogsFeedShareCurtainOptionTitle: 'Link kopieren',
  blogsFeedPostLinkCopiedAlertText: 'Link kopiert!',
  blogsFeedOthersPostCurtainOptionCopyTitle: 'Link kopieren',
  blogsFeedOthersPosLinkCopiedAlertText: 'Link kopiert!',
  blogsFeedOthersPostCurtainOptionFlagTitle: 'Melden',
  blogsFeedOtherPostOwnersCurtainDeleteTitle: 'Beitrag löschen',
  blogsFeedPostDeletePopupTitle: 'Löschen',
  blogsFeedPostDeletePopupText: 'Diesen Beitrag löschen?',
  blogsFeedPostDeletePopupCancelButtonTitle: 'Abbrechen',
  blogsFeedPostDeletePopupConfirmButtonTitle: 'Bestätigen',
  blogsFeedPostDeeletedAlertText: 'Beitrag gelöscht!',
  blogsPostDetailsHeaderTitle: 'Beitrag',
  postFeedPostLikesText: 'Likes',
  postFeedPostCommentsText: 'Kommentare',
  postFeedPostNoLikesText: 'Es gibt noch keine Likes',
  postFeedPostLeaveFirstLikeText: 'Du kannst der Erste sein, der einen Like gibt',
  blogsFeedPostDetailsNoCommentsText: 'Es gibt noch keine Kommentare',
  blogsFeedPostDetailsFirstCommentText: 'Du kannst der Erste sein, der kommentiert',
  blogsFeedPostDetailsShareOptionTitle: 'Link kopieren',
  blogsFeedPostDetailsSharePostCopiedAlertText: 'Link kopiert!',
  blogsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Link kopieren',
  blogsFeedPostDetailsCopiedAlertText: 'Link kopiert!',
  blogsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Melden',
  blogsPostDetailsFlagCurtainOptionSpamTitle: 'Melden',
  blogsPostDetailsReportedCurtainText: 'Inhalt gemeldet',
  blogsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Kommentar bearbeiten',
  blogsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Kommentar löschen',
  blogsPostDetailsEditedCommentSavedAlertText: 'Kommentar gespeichert!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Kommentar löschen',
  postDetailsOtherUsersCommentDeletadAlertText: 'Kommentar gelöscht!',
  postDetailsDeleteCommentPopupTitle: 'Löschen',
  postDetailsDeleteCommentPopupText: 'Diesen Kommentar löschen?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Abbrechen',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Bestätigen',
  postDetailsCommDeletedAlertText: 'Kommentar gelöscht!',
  postDetailsCommentUserCurtainOptionTitle: 'Kommentar melden',
  blogsCreatePostCurtainTitle: 'Neuer Beitrag',
  blogsCreatePostCurtainBodyPlaceholder: 'Schreibe deinen Text hier...',
  blogsCreatePostPublishButtonTitle: 'Veröffentlichen',
  blogsCreatePostUploadSlallerImageAlertText: 'Du kannst maximal {size} MB auf einmal hochladen',
  blogsPostSavedAlertText: 'Beitrag gespeichert!',
  blogsCreatePostAddLocationCurtainTitle: 'Ort',
  blogsCreatePostAddLocationCurtainInputPlaceholder: 'Ortsname',
  blogsCreatePostEditLocationCurtainText: 'Ort bearbeiten',
  blogsDeleteLocation: 'Ort löschen',
  blogsDiscardPostPopupTitle: 'Entwurf',
  blogsDiscardPostPopupText: 'Diesen Entwurf verwerfen?',
  blogsDiscardPostPopupCancelButtonTitle: 'Abbrechen',
  blogsDiscardPostPopupCofirmButtonTitle: 'Bestätigen',
  blogsNewPostCreatePollTitle: 'Umfrage erstellen',
  blogsNewPostCreatePollTitleInputPlaceholder: 'Titel',
  blogsNewPostCreatePollOptionInputPlaceholder: 'Option',
  blogsNewPostCreatePollAddButtonTitle: 'Option hinzufügen',
  blogsNewPostCreatePollCreateButtonTitle: 'Erstellen',
  blogsCreatePostPollTitleBlankAlertText: 'Titel darf nicht leer sein!',
  blogsCreatePostPollOptionBlankAlertText: 'Option darf nicht leer sein!',
  blogsCreatePostPollLongTitleAlertText: 'Titel darf maximal {length} Zeichen enthalten',
  blogsCreatePostPollLongOptionAlertText: 'Option darf maximal {length} Zeichen enthalten',
  blogsCreatePostPollEditOptionTitle: 'Umfrage bearbeiten',
  blogsCreatePostPollRemoveOptionTitle: 'Umfrage entfernen',
  blogsPostPollInfoVotesText: 'Stimmen',
  blogsPostPollInfoEditVoteText: 'Stimme bearbeiten',
  blogsPostPollFinishPollText: 'Umfrage beenden',
  blogsPostPollFinishedPollText: 'Beendet',
  blogsPostPollInProgresslText: 'In Bearbeitung',
  blogsFinishPollCurtainTitle: 'Umfrage beenden',
  blogsFinishPollCurtainText: 'Benutzer können nicht mehr abstimmen, nachdem die Umfrage beendet ist.',
  blogsFinishPollCurtainCancelButtonTitle: 'Abbrechen',
  blogsFinishPollCurtainConfirmlButtonTitle: 'Bestätigen',
  blogsPollInfoPollVotesCurtainTitle: 'Umfrageergebnisse',
  blogsEditPostCurtainTitle: 'Beitrag bearbeiten',
  blogsEditPostCurtainNoTextBodyPlaceholder: 'Schreibe deinen Text hier...',
  blogsEditPostCurtainSaveButtonTitle: 'Speichern',
  blogsEditPostSavedAlertText: 'Beitrag gespeichert!',
  blogsError: 'Etwas ist schiefgelaufen!',
  blogsAt: 'um',
  blogsSeeMore: 'Mehr anzeigen...',
  blogsMaxAttachments: 'Sie haben die maximale Anzahl an Anhängen überschritten. Die maximale Anzahl an Anhängen beträgt {length}',
  blogsReply: 'Antworten',
  blogsAddCover: 'Titelbild hinzufügen'
}
